import { useSelector } from "react-redux";
import { NavLink, Outlet } from "react-router-dom";
import "./Account.css";

const accountNavbar = () => {
  const role = useSelector((store) => store.userReducer.role);
  return (
    <>
      <nav className="navbar-activity">
        <div className="nav-links-activity">
          {(role == "super" ||
            role == "operation" ||
            role == "subSuper" ||
            role == "subAdmin" ||
            role === "admin") && (
            <NavLink
              to="/account/details"
              className={({ isActive }) => (isActive ? "active-tab" : "")}
            >
              Accounts
            </NavLink>
          )}
          {(role == "super" || role == "operation" || role == "subSuper") && (
            <NavLink
              to="/account/merchant-webhooks"
              className={({ isActive }) => (isActive ? "active-tab" : "")}
            >
              Webhooks
            </NavLink>
          )}
          {(role == "super" || role == "operation" || role == "subSuper") && (
            <NavLink
              to="/account/api-key"
              className={({ isActive }) => (isActive ? "active-tab" : "")}
            >
              API Keys
            </NavLink>
          )}

          {(role == "super" ||
            role == "operation" ||
            role == "subSuper" ||
            role == "subAdmin" ||
            role === "admin") && (
            <NavLink
              data-tour="server-ip-tab"
              to="/account/ips-merchant"
              className={({ isActive }) => (isActive ? "active-tab" : "")}
            >
              IPs
            </NavLink>
          )}
        </div>
      </nav>
      <div>
        <Outlet />
      </div>
    </>
  );
};

export default accountNavbar;
